import { Select } from 'antd';
import styles from './index.less';
import { useEffect } from 'react';

const {Option} = Select;

const DEFAULT_SCROLL_HOUR = "08:00"
const ITEM_HEIGHT = 32;

const timeOptions = Array.from({length: 96}, (_, i) => {
  const hours = String(Math.floor(i / 4)).padStart(2, '0');
  const minutes = String((i % 4) * 15).padStart(2, '0');
  return `${hours}:${minutes}`;
});

const HourSelector = ({from, to, value, onChange, placeholder, fromInclusive = false, toInclusive = false, excludeRanges = []}) => {
  const popupClassName = styles.hourSelectorDropdown

  const getOptions = () => timeOptions.filter((time) => {
    let isValid = true;
    if (from) {
      isValid = isValid && (fromInclusive ? time >= from : time > from);
    }
    if (to) {
      isValid = isValid && (toInclusive ? time <= to : time < to);
    }
    if (excludeRanges && excludeRanges.length > 0) {
      const isExcluded = excludeRanges.some(range => {
        if (!range.start || !range.end) return false;
        return time > range.start && time < range.end;
      });
      isValid = isValid && !isExcluded;
    }
    return isValid;
  })

  const options = getOptions()

  const scrollToTime = (targetTime: string) => {
    const index = timeOptions.findIndex((t) => t === targetTime);
    if (index === -1) return;

    setTimeout(() => {
      const list = document.querySelectorAll(`.${popupClassName} .rc-virtual-list-holder`);
      for (const el of list) {
        el.scrollTop = index * ITEM_HEIGHT;
      }
    }, 50);
  };

  const onOpenChange = open => {
    if (open && !value) {
      scrollToTime(DEFAULT_SCROLL_HOUR)
    }
  }

  useEffect(() => {
    const isExcluded = excludeRanges?.some(range => range.start && range.end && value > range.start && value < range.end);

    if (from && value && value < from) {
      const nextAvailable = options.find(time => time >= from)
      onChange(nextAvailable)
      return
    }
    if (to && value && value > to) {
      const nextAvailable = [...options].reverse().find(time => time <= to)
      onChange(nextAvailable)
      return
    }
    if (isExcluded) {
      const nextAvailable = options.find(time => time >= value)
      onChange(nextAvailable)
      return
    }
  }, [from, to, excludeRanges]);
  return <Select
    value={value}
    onChange={onChange}
    showSearch
    variant={"underlined"}
    className={styles.hourSelectorSelect}
    classNames={{
      popup: {
        root: popupClassName
      }
    }}
    style={{width: 90}}
    placeholder={placeholder}
    onOpenChange={onOpenChange}
    virtual={false}
    size={"small"}
    optionFilterProp="children"
    filterOption={(input, option) =>
      option?.children?.toLowerCase().includes(input.toLowerCase())
    }
  >
    {options.map((time, index) => (
      <Option key={time} value={time}>
        {time}
      </Option>
    ))}
  </Select>
}

export default HourSelector;
